import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { CustomHttp, ConfigServerService } from '../../../core';
import { PessoaEnderecoTipo, PessoaEndereco } from '../endereco';
import { PessoaCidadeEstado } from '../cidade-estado';

@Injectable({
    providedIn: 'root'
})
export class PessoaEnderecoHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/pessoa`;
    }

    /** Procura o endereço da pessoa e tipo informados */
    findEndereco(id: number, tipo: PessoaEnderecoTipo): Observable<PessoaEndereco> {
        // Params
        const params = new HttpParams()
                            .append('tipo', tipo ? tipo.id.toString() : 'null');

        return this.customHttp.get<PessoaEndereco>(`${this.pathApi}/${id}/endereco`, {params});
    }

    /** Obtem o nome da cidade e estado da pessoa */
    getCidadeEstado(id: number): Observable<PessoaCidadeEstado> {
        return this.customHttp.get(`${this.pathApi}/${id}/cidadeestado`);
    }
}
